import React from 'react';
import Parallax from "./Parallax/parallax";
import ContentWrapper from "./ContentWrapperRow";

interface ElementWrapperProps {
    contentKey: string;
    currentContent: any;
}

const elementWrapper: React.FC<ElementWrapperProps> = ({contentKey, currentContent}) => {
    return (
        <>
            <div id={contentKey} style={{height: "0px"}}></div>
            <div className="sticky-top text-justify">
                {(currentContent.parallax) ?
                    <Parallax
                        backgroundImageUrl={`/images/${currentContent.imagen}`}
                        minHeight="100vh"
                    >
                        <ContentWrapper contentKey={contentKey}
                                        currentContent={currentContent}/>
                    </Parallax>
                    :
                    <ContentWrapper contentKey={contentKey}
                                    currentContent={currentContent}/>
                }
            </div>
        </>
    )
}

export default elementWrapper;